module.exports = __webpack_public_path__ + "static/media/error-light-circular.b21d10fc.png";